// Shared WebRTC call helpers for Messenger (status labels + actionable media errors).
export const RING_TIMEOUT_MS = 45000;

export function mediaSupportError(kind) {
  if (!window.isSecureContext) return "Calling needs a secure (HTTPS) connection.";
  if (!navigator.mediaDevices?.getUserMedia || !window.RTCPeerConnection) return "This browser does not support in-app calls.";
  return null;
}

export function mediaErrorMessage(e, kind) {
  const dev = kind === "video" ? "camera and microphone" : "microphone";
  switch (e?.name) {
    case "NotAllowedError":
    case "SecurityError": return `Permission to use your ${dev} was denied. Allow it in your browser's site settings and try again.`;
    case "NotFoundError":
    case "OverconstrainedError": return `No ${dev} was found on this device.`;
    case "NotReadableError":
    case "AbortError": return `Your ${dev} is busy in another app. Close it and try again.`;
    default: return `Could not start the ${kind} call.`;
  }
}

const ENDED = { declined: "Declined", no_answer: "No answer", missed: "Missed call", busy: "Busy on another call",
  failed: "Call failed: could not connect (network may need a relay)", lost: "Call ended: connection lost", offline: "Unavailable: they are offline and were notified", rate_limited: "Too many call attempts, try again shortly", media: "Call not started: camera or microphone unavailable", ended: "Call ended" };

// Never claims "Connected" without RTCPeerConnection.connectionState === "connected".
export function callStatusLabel(call) {
  if (!call) return "";
  if (call.mode === "ended") return ENDED[call.reason] || "Call ended";
  if (call.mode === "incoming") return "Incoming call";
  if (call.mode === "outgoing") return call.ringing ? "Ringing…" : "Calling…";
  return { connected: "Connected", disconnected: "Reconnecting…", failed: "Connection failed" }[call.net] || "Connecting…";
}
